"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formQuestionsAreSame = void 0;
const FormQuestionControllerRegistry_1 = __importDefault(require("../FormQuestionController/FormQuestionControllerRegistry"));
function formQuestionsAreSame(a, b) {
    if ((a === null || a === void 0 ? void 0 : a.length) !== (b === null || b === void 0 ? void 0 : b.length))
        return false;
    return !a.some((aQ, idx) => !FormQuestionControllerRegistry_1.default[aQ.type].areSame(aQ, b[idx]));
}
exports.formQuestionsAreSame = formQuestionsAreSame;
exports.default = formQuestionsAreSame;
